import * as sentry from '@sentry/browser';
import apolloClient from 'services/apollo-client';
import { ApolloClient } from '@apollo/client';
import { surfaceNodesQuery } from 'graphql/surface-node/queries/surface-nodes';
import useCurrentSurface from 'routes/surface/hooks/use-current-surface';

type Input = { surface?: string; cache?: ApolloClient<any> };

export function useFetchSurfaceNodesFromCache(
  surfaceId?: string,
): (input?: Input) => any {
  const currentSurface = useCurrentSurface();

  surfaceId = surfaceId ?? currentSurface?.id;

  return function fetchSurfaceNodesFromCache(input?: Input) {
    const { surface = surfaceId, cache = apolloClient } = input || {};

    try {
      const variables = {
        input: { filter: { surface } },
      };

      const result = cache.readQuery<any>({
        query: surfaceNodesQuery,
        variables,
      });

      return result?.surfaceNodes?.nodes ?? [];
    } catch (error) {
      console.error(error);
      sentry.captureException(error);

      return [];
    }
  };
}

export default useFetchSurfaceNodesFromCache;
